import { BiCollapse, BiCross, BiHome, BiLogoChrome, BiLogoEdge, BiMenu, BiPencil, BiPlay, BiPlus, BiSolidVolume, BiSolidVolumeMute, BiX } from "react-icons/bi";

//#region interfaces
interface IGUIItemProps {
  size: number,
  items: number | null,
  s: number[],
  t: number[],
  isEditMode?: boolean
}
interface IGetAddNewItemProps {
  size: number,
  scale: number | null,
  t: number[],
  onClick: ((it: any) => void)
}
interface IGetAddNewItemProps1 {
  size: string[],
  scale: number,
  t: number[],
  onClick: (() => void)
}
//#endregion

export default class AppSVGStore {

  private static fontSize = 50;

  public static getSupportedBrowseres({ size = 30, scale = 1, t = [0, 0], onClick = () => { } }: Partial<IGetAddNewItemProps> = {}): JSX.Element {

    return <svg x="0px" y="0px" height={size}>
      <svg x="0px" y="0px"
        width={size} height={size}
        viewBox="0 0 48 48">
        <path fill="#fff" d="M34,24c0,5.521-4.479,10-10,10s-10-4.479-10-10s4.479-10,10-10S34,18.479,34,24z"></path><linearGradient id="Pax8JcnMzivu8f~SZ~k1ya_ejub91zEY6Sl_gr1" x1="5.789" x2="31.324" y1="34.356" y2="20.779" gradientTransform="matrix(1 0 0 -1 0 50)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#4caf50"></stop><stop offset=".489" stop-color="#4aaf50"></stop><stop offset=".665" stop-color="#43ad50"></stop><stop offset=".79" stop-color="#38aa50"></stop><stop offset=".892" stop-color="#27a550"></stop><stop offset=".978" stop-color="#11a050"></stop><stop offset="1" stop-color="#0a9e50"></stop></linearGradient><path fill="url(#Pax8JcnMzivu8f~SZ~k1ya_ejub91zEY6Sl_gr1)" d="M31.33,29.21l-8.16,14.77C12.51,43.55,4,34.76,4,24C4,12.96,12.96,4,24,4v11 c-4.97,0-9,4.03-9,9s4.03,9,9,9C27.03,33,29.7,31.51,31.33,29.21z"></path><linearGradient id="Pax8JcnMzivu8f~SZ~k1yb_ejub91zEY6Sl_gr2" x1="33.58" x2="33.58" y1="6" y2="34.797" gradientTransform="matrix(1 0 0 -1 0 50)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ffd747"></stop><stop offset=".482" stop-color="#ffd645"></stop><stop offset=".655" stop-color="#fed43e"></stop><stop offset=".779" stop-color="#fccf33"></stop><stop offset=".879" stop-color="#fac922"></stop><stop offset=".964" stop-color="#f7c10c"></stop><stop offset="1" stop-color="#f5bc00"></stop></linearGradient><path fill="url(#Pax8JcnMzivu8f~SZ~k1yb_ejub91zEY6Sl_gr2)" d="M44,24c0,11.05-8.95,20-20,20h-0.84l8.17-14.79C32.38,27.74,33,25.94,33,24 c0-4.97-4.03-9-9-9V4c7.81,0,14.55,4.48,17.85,11C43.21,17.71,44,20.76,44,24z"></path><linearGradient id="Pax8JcnMzivu8f~SZ~k1yc_ejub91zEY6Sl_gr3" x1="36.128" x2="11.574" y1="44.297" y2="28.954" gradientTransform="matrix(1 0 0 -1 0 50)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f7572f"></stop><stop offset=".523" stop-color="#f7552d"></stop><stop offset=".712" stop-color="#f75026"></stop><stop offset=".846" stop-color="#f7461b"></stop><stop offset=".954" stop-color="#f7390a"></stop><stop offset="1" stop-color="#f73100"></stop></linearGradient><path fill="url(#Pax8JcnMzivu8f~SZ~k1yc_ejub91zEY6Sl_gr3)" d="M41.84,15H24c-4.97,0-9,4.03-9,9c0,1.49,0.36,2.89,1.01,4.13H16L7.16,13.26H7.14 C10.68,7.69,16.91,4,24,4C31.8,4,38.55,8.48,41.84,15z"></path><linearGradient id="Pax8JcnMzivu8f~SZ~k1yd_ejub91zEY6Sl_gr4" x1="19.05" x2="28.95" y1="30.95" y2="21.05" gradientTransform="matrix(1 0 0 -1 0 50)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#2aa4f4"></stop><stop offset="1" stop-color="#007ad9"></stop></linearGradient><path fill="url(#Pax8JcnMzivu8f~SZ~k1yd_ejub91zEY6Sl_gr4)" d="M31,24c0,3.867-3.133,7-7,7s-7-3.133-7-7s3.133-7,7-7S31,20.133,31,24z"></path>
      </svg>
      <svg x={size} y="0px" width={size} height={size} viewBox="0 0 48 48">
        <path fill="#1de9b6" d="M4,23.481C4,15.673,10.557,4,24.014,4C37.452,4,44,13.923,44,20.905c0,5.604-4.429,9.732-9.992,9.732	c-4.245,0-6.759-1.408-6.759-2.53c0-0.726,1.755-1.837,1.755-3.982c0-2.565-1.986-5.137-5.045-5.137	c-2.934,0-4.974,2.442-4.974,4.905c0,5.952,5.63,11.644,13.931,11.644c4.959,0,6.759-1.828,7.403-1.828	c0.196,0,0.647,0.08,0.647,0.603c0,0.5-5.486,9.686-16.94,9.686C12.632,44,4,35.023,4,23.481z"></path><radialGradient id="2pm2zgLwrfHW4PMfqfOjYa_dGm9KIZPpukc_gr1" cx="17.993" cy="32.825" r="21.348" gradientTransform="matrix(1 0 0 1.1083 0 -3.529)" gradientUnits="userSpaceOnUse"><stop offset=".652" stop-color="#0083de"></stop><stop offset=".822" stop-color="#006aac"></stop><stop offset=".944" stop-color="#005a8c"></stop></radialGradient><path fill="url(#2pm2zgLwrfHW4PMfqfOjYa_dGm9KIZPpukc_gr1)" d="M4,23.481c0-7.808,7.615-12.04,12.73-12.04c13.439,0,17.277,2.483,17.277,9.465	c0,5.604-5.003,5.366-5.003,3.221c0-2.565-1.986-5.137-5.045-5.137c-2.934,0-4.974,2.442-4.974,4.905	c0,5.952,5.63,11.644,13.931,11.644c4.959,0,6.759-1.828,7.403-1.828c0.196,0,0.647,0.08,0.647,0.603c0,0.5-5.486,9.686-16.94,9.686	C12.632,44,4,35.023,4,23.481z"></path><radialGradient id="2pm2zgLwrfHW4PMfqfOjYb_dGm9KIZPpukc_gr2" cx="28.082" cy="29.295" r="16.478" gradientTransform="matrix(1 0 0 1.0028 0 -.067)" gradientUnits="userSpaceOnUse"><stop offset=".69" stop-color="#05509b"></stop><stop offset=".717" stop-color="#054e98"></stop><stop offset="1" stop-color="#033e78"></stop></radialGradient><path fill="url(#2pm2zgLwrfHW4PMfqfOjYb_dGm9KIZPpukc_gr2)" d="M18.985,23.894c0-2.298,1.775-4.575,4.395-4.871c-4.104,0.349-8.798,4.375-8.798,11.831	c0,7.963,6.864,13.465,13.943,12.628c8.386-1.927,12.441-8.74,12.441-9.168c0-0.523-0.451-0.603-0.647-0.603	c-0.643,0-2.444,1.828-7.403,1.828C24.615,35.539,18.985,29.847,18.985,23.894z"></path><radialGradient id="2pm2zgLwrfHW4PMfqfOjYc_dGm9KIZPpukc_gr3" cx="47.648" cy="16.079" r="61.532" gradientTransform="matrix(-1 0 0 -1.5084 95.296 40.31)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#5eeb69"></stop><stop offset=".214" stop-color="#4bc958"></stop><stop offset=".225" stop-color="#4ac862"></stop><stop offset=".272" stop-color="#47c68b"></stop><stop offset=".323" stop-color="#44c4ae"></stop><stop offset=".376" stop-color="#41c2cb"></stop><stop offset=".433" stop-color="#3fc1e1"></stop><stop offset=".495" stop-color="#3ec0f1"></stop><stop offset=".565" stop-color="#3dbffa"></stop><stop offset=".664" stop-color="#3dbffd"></stop></radialGradient><path fill="url(#2pm2zgLwrfHW4PMfqfOjYc_dGm9KIZPpukc_gr3)" d="M4,23.481C4,15.673,10.557,4,24.014,4C37.452,4,44,13.923,44,20.905	c0,5.604-4.429,9.732-9.992,9.732c-4.245,0-6.759-1.408-6.759-2.53c0-0.726,1.755-1.837,1.755-3.982	c0-2.565-2.076-10.678-12.628-10.678C13.442,13.448,5.256,14.745,4,23.481z"></path>
      </svg>
      <svg x={2 * size} y="0px" width={size} height={size} viewBox="0 0 48 48">
        <linearGradient id="yG17B1EwMCiUUe9ON9hI5a_cM42lftaD9Z3_gr1" x1="-329.441" x2="-329.276" y1="-136.877" y2="-136.877" gradientTransform="matrix(217.6 0 0 -255.4727 71694.719 -34944.293)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#e68e00"></stop><stop offset=".437" stop-color="#d75500"></stop><stop offset=".562" stop-color="#cf3600"></stop><stop offset=".89" stop-color="#d22900"></stop><stop offset="1" stop-color="#d42400"></stop></linearGradient><path fill="url(#yG17B1EwMCiUUe9ON9hI5a_cM42lftaD9Z3_gr1)" fill-rule="evenodd" d="M40.635,13.075l0.984-2.418c0,0-1.252-1.343-2.772-2.865	s-4.74-0.627-4.74-0.627L30.439,3H24h-6.439l-3.667,4.165c0,0-3.22-0.895-4.74,0.627s-2.772,2.865-2.772,2.865l0.984,2.418	l-1.252,3.582c0,0,3.682,13.965,4.114,15.671c0.85,3.358,1.431,4.656,3.846,6.358c2.415,1.701,6.797,4.656,7.512,5.104	C22.301,44.237,23.195,45,24,45c0.805,0,1.699-0.763,2.415-1.21c0.715-0.448,5.098-3.403,7.512-5.104	c2.415-1.701,2.996-3,3.846-6.358c0.431-1.705,4.114-15.671,4.114-15.671L40.635,13.075z" clip-rule="evenodd"></path><linearGradient id="yG17B1EwMCiUUe9ON9hI5b_cM42lftaD9Z3_gr2" x1="19.087" x2="31.755" y1="7.685" y2="32.547" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"></stop><stop offset=".24" stop-color="#f8f8f7"></stop><stop offset="1" stop-color="#e3e3e1"></stop></linearGradient><path fill="url(#yG17B1EwMCiUUe9ON9hI5b_cM42lftaD9Z3_gr2)" fill-rule="evenodd" d="M33.078,9.807c0,0,4.716,5.709,4.716,6.929	s-0.593,1.542-1.19,2.176c-0.597,0.634-3.202,3.404-3.536,3.76c-0.335,0.356-1.031,0.895-0.621,1.866	c0.41,0.971,1.014,2.206,0.342,3.459c-0.672,1.253-1.824,2.089-2.561,1.951c-0.738-0.138-2.471-1.045-3.108-1.459	c-0.637-0.414-2.657-2.082-2.657-2.72c0-0.638,2.088-1.784,2.473-2.044c0.386-0.26,2.145-1.268,2.181-1.663	c0.036-0.396,0.022-0.511-0.497-1.489c-0.519-0.977-1.454-2.281-1.298-3.149c0.156-0.868,1.663-1.319,2.74-1.726	c1.076-0.407,3.148-1.175,3.406-1.295c0.259-0.12,0.192-0.233-0.592-0.308c-0.784-0.074-3.009-0.37-4.012-0.09	c-1.003,0.28-2.717,0.706-2.855,0.932c-0.139,0.226-0.261,0.233-0.119,1.012c0.142,0.779,0.876,4.517,0.948,5.181	c0.071,0.664,0.211,1.103-0.504,1.267c-0.715,0.164-1.919,0.448-2.332,0.448s-1.617-0.284-2.332-0.448	c-0.715-0.164-0.576-0.603-0.504-1.267s0.805-4.402,0.948-5.181c0.142-0.779,0.02-0.787-0.119-1.012	c-0.139-0.226-1.852-0.652-2.855-0.932c-1.003-0.28-3.228,0.016-4.012,0.09c-0.784,0.074-0.851,0.188-0.592,0.308	c0.259,0.119,2.331,0.888,3.406,1.295c1.076,0.407,2.584,0.858,2.74,1.726c0.156,0.868-0.779,2.172-1.298,3.149	c-0.519,0.977-0.533,1.093-0.497,1.489c0.036,0.395,1.795,1.403,2.181,1.663c0.386,0.26,2.473,1.406,2.473,2.044	c0,0.638-2.02,2.306-2.657,2.72c-0.637,0.414-2.37,1.321-3.108,1.459c-0.738,0.138-1.889-0.698-2.561-1.951	c-0.672-1.253-0.068-2.488,0.342-3.459c0.41-0.971-0.287-1.51-0.621-1.866c-0.334-0.356-2.94-3.126-3.536-3.76	c-0.597-0.634-1.19-0.956-1.19-2.176s4.716-6.929,4.716-6.929s3.98,0.761,4.516,0.761c0.537,0,1.699-0.448,2.772-0.806	C23.285,9.404,24,9.401,24,9.401s0.715,0.003,1.789,0.361c1.073,0.358,2.236,0.806,2.772,0.806	C29.098,10.568,33.078,9.807,33.078,9.807z M29.542,31.643c0.292,0.183,0.114,0.528-0.152,0.716	c-0.266,0.188-3.84,2.959-4.187,3.265c-0.347,0.306-0.857,0.812-1.203,0.812c-0.347,0-0.856-0.506-1.203-0.812	c-0.347-0.306-3.921-3.077-4.187-3.265c-0.266-0.188-0.444-0.533-0.152-0.716c0.292-0.183,1.205-0.645,2.466-1.298	c1.26-0.653,2.831-1.208,3.076-1.208c0.245,0,1.816,0.555,3.076,1.208C28.336,30.999,29.25,31.46,29.542,31.643z" clip-rule="evenodd"></path><linearGradient id="yG17B1EwMCiUUe9ON9hI5c_cM42lftaD9Z3_gr3" x1="-329.279" x2="-329.074" y1="-140.492" y2="-140.492" gradientTransform="matrix(180.608 0 0 -46.0337 59468.86 -6460.583)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#e68e00"></stop><stop offset="1" stop-color="#d42400"></stop></linearGradient><path fill="url(#yG17B1EwMCiUUe9ON9hI5c_cM42lftaD9Z3_gr3)" fill-rule="evenodd" d="M34.106,7.165L30.439,3H24h-6.439l-3.667,4.165	c0,0-3.22-0.895-4.74,0.627c0,0,4.293-0.388,5.769,2.015c0,0,3.98,0.761,4.516,0.761c0.537,0,1.699-0.448,2.772-0.806	C23.285,9.404,24,9.401,24,9.401s0.715,0.003,1.789,0.361c1.073,0.358,2.236,0.806,2.772,0.806c0.537,0,4.516-0.761,4.516-0.761	c1.476-2.403,5.769-2.015,5.769-2.015C37.326,6.27,34.106,7.165,34.106,7.165" clip-rule="evenodd"></path>
      </svg>
      <svg x={3 * size} y="0px" width={size} height={size} viewBox="0 0 48 48">
        <path fill="#ff1744" d="M24,4C12.947,4,4,12.947,4,24s8.947,20,20,20s20-8.947,20-20S35.053,4,24,4z M24,39c-5.263,0-10-6.896-10-15S18.737,9,24,9s10,6.896,10,15S29.263,39,24,39z"></path><path fill="#d50000" d="M36.564,8.445C34.413,6.972,31.89,6,29.263,6c-3.948,0-7.524,1.98-10.166,5.079C20.573,9.77,22.255,9,24,9c5.263,0,10,6.896,10,15s-4.737,15-10,15c-1.745,0-3.427-0.77-4.903-2.079C21.739,40.02,25.315,42,29.263,42c2.626,0,5.15-0.972,7.3-2.444C41.097,35.891,44,30.29,44,24C44,17.711,41.097,12.11,36.564,8.445z"></path>
      </svg>
    </svg>
  }

  public static getPlay({ size = ["30%", "30%"], scale = 1, t = [0, 0], onClick = () => { }, }: Partial<IGetAddNewItemProps1> = {}): JSX.Element {

    const sizeButton = 40;
    let transform = "scale(1,1) translate(" + (-0.05 * sizeButton) + "," + (-0.1 * sizeButton) + ")"

    return (
      <>
        <svg
          onClick={(it) => { onClick() }}
          width={size[0]}
          height={size[1]}
          viewBox="0 0 32 32">

          <g
            transform={"translate(9.5,10)"}
          >
            <svg
              width={"40%"}
              height={"40%"}
              viewBox="0 0 32 32"
            >

              <circle cx={"50%"} cy={"50%"} r={"50%"} fill="#ffffff" />
              <g transform={transform}>
                <BiPlay color="#000" size={sizeButton} />
              </g>


            </svg>
          </g>
        </svg>

      </>

    )
  }

  public static getUnMuteButton({ size = ["30%", "30%"], scale = 1, t = [0, 0], onClick = () => { }, }: Partial<IGetAddNewItemProps1> = {}): JSX.Element {

    let transform = "scale(" + scale + "," + scale + ") translate(" + t[0] + "," + t[1] + ")"// translate(48,48)"
    //let transformButton = "scale(0.75,0.75) translate(13,10)"
    const sizeMute = 25;
    let transformMute = "scale(1,1) translate(" + 0.22 * sizeMute + "," + 0.15 * sizeMute + ")"// translate(48,48)"

    return (
      <>
        <svg
          onClick={(it) => { onClick() }}
          width={size[0]}
          height={size[1]}
          viewBox="0 0 32 32">

          <g
            transform={"translate(12.1,12)"}
          >
            <svg
              width={"25%"}
              height={"25%"}
              viewBox="0 0 32 32"
            >

              <circle cx={"50%"} cy={"50%"} r={"50%"} fill="#ffffff" />
              <g
                transform={transformMute}
              >
                <BiSolidVolume color="#000" size={25} />
              </g>


            </svg>
          </g>
        </svg>

      </>
    )
  }


  public static getGooglePlay({ size = 70, scale = 1, t = [0, 0], onClick = (it: any) => { } }: Partial<IGetAddNewItemProps> = {}): JSX.Element {
    let transform = "scale(" + scale + "," + scale + ") translate(" + t[0] + "," + t[1] + ")"
    return (
      <>
        <svg
          viewBox="0 0 24 27"
          width={size}
          height={size}
          //className="outline-none shrink-0 w-7 h-7 shrink-0" 
          aria-hidden="true"
        >
          <g transform={transform}>
            <path fill="#EA4335" d="M11.202 12.81.104 24.594A3 3 0 0 0 4.527 26.4l.031-.021 12.496-7.207-5.852-6.373z"></path>
            <path fill="#FBBC04" d="M22.446 10.806h-.01l-5.393-3.14-6.081 5.413 6.102 6.102 5.371-3.098a3 3 0 0 0 1.575-2.639 2.97 2.97 0 0 0-1.564-2.628z"></path>
            <path fill="#4285F4" d="M.104 2.232c-.062.25-.104.501-.104.772v20.83c0 .27.031.521.104.771l11.484-11.483z"></path>
            <path fill="#34A853" d="m11.286 13.413 5.747-5.747L4.548.428A3 3 0 0 0 .105 2.222l11.191 11.18z">
            </path>
          </g>
        </svg></>)
  }



  //#region common
  public static getMenu({ size = 30, t = [0, 0] }: Partial<IGUIItemProps> = {}): JSX.Element {
    return (
      <BiMenu size={size} />)
  }


  public static getClose({ size = 30, t = [0, 0] }: Partial<IGUIItemProps> = {}): JSX.Element {
    return (
      <BiX size={size} />
    );
  }

  public static getHome({ size = 30, t = [0, 0] }: Partial<IGUIItemProps> = {}): JSX.Element {
    return (
      <BiHome size={size} />
    );
  }

  public static getService({ size = 30, t = [0, 0] }: Partial<IGUIItemProps> = {}): JSX.Element {
    return (
      <BiHome size={size} />
    );
  }

  public static PrivcayPolicy({ size = 30, t = [0, 0] }: Partial<IGUIItemProps> = {}): JSX.Element {
    return (
      <BiHome size={size} />
    );
  }

  public static getWebsite({ size = 30, t = [0, 0] }: Partial<IGUIItemProps> = {}): JSX.Element {
    return (
      <BiHome size={size} />
    );
  }

  public static getAndroidApp({ size = 30, t = [0, 0] }: Partial<IGUIItemProps> = {}): JSX.Element {
    return (
      <BiHome size={size} />
    );
  }
  //#endregion


  //#region unassigned
  public static getTrashBin({ size = 64, t = [0, 0] }: Partial<IGUIItemProps> = {}): JSX.Element {
    let transform = "scale(1.25,1.25) translate(" + t[0] + "," + t[1] + ")"
    return (
      <svg
        viewBox="0 0 32 32"
        height={size} width={size} >
        <g transform={transform}>
          <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path><path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
        </g>
      </svg>
    )
  }

  public static getPentagon({ size = 140, t = [0, 0] }: Partial<IGUIItemProps> = {}): JSX.Element {
    return (
      <svg
        fill="lightgrey"
        height={size} width={size}
        viewBox="0 0 512 512"
      >
        <g>
          <g>
            <path d="M507.807,200.272L262.474,12.859c-3.819-2.923-9.109-2.923-12.949,0L4.191,200.272c-3.627,2.773-5.077,7.509-3.648,11.84
            l93.717,281.92c1.451,4.352,5.547,7.296,10.133,7.296h303.253c4.608,0,8.683-2.944,10.091-7.296l93.717-281.92
            C512.885,207.803,511.413,203.046,507.807,200.272z M399.946,479.995H112.095L23.221,212.582L256.031,34.747l232.811,177.856
            L399.946,479.995z"/>
          </g>
        </g>
      </svg>)
  }


  public static getCamera({ size = 64, t = [0, 0] }: Partial<IGUIItemProps> = {}): JSX.Element {
    return (
      <svg
        viewBox="0 0 512 512"
        height={size} width={size}
        stroke="currentColor" fill="currentColor" strokeWidth="0" >
        <path d="M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"></path>
      </svg>
    )
  }
  //#endregion


  //#region print
  public static getCreatePDF({ size = 30, t = [0, 0], onClick = (it: any) => { } }: Partial<IGetAddNewItemProps> = {}): JSX.Element {
    let transform = "scale(1,1) translate(" + t[0] + "," + t[1] + ")";

    return <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      height={size} width={size}
    >
      <g transform={transform}>
        <path d="M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"></path>
      </g>
    </svg>

  }
  //#endregion


  //#region internal
  private static getItemsText({ size = 64, t = [0, 0], items = null }: Partial<IGUIItemProps> = {}): JSX.Element {
    //let transform = "scale(1,1) translate(" + t[0] + "," + t[1] + ")"
    return (
      <svg
        fill="#000"
        viewBox="0 0 128 128"
      //height={"100%"} width={"100%"}
      //height={size} width={size} 
      >
        <text x="50%" y={"100%"} fontSize={this.fontSize} textAnchor="middle"  >
          {items}
        </text>
      </svg>)
  }


  public static getEdit({ size = 30, t = [0, 0], items = null }: Partial<IGUIItemProps> = {}): JSX.Element {
    let transform = "scale(0.75,0.75) translate(" + t[0] + "," + t[1] + ")"

    return (
      <svg viewBox="-15 -15 32 32"
        height={size} width={size}
        fill="#f00">
        <g transform={transform}>
          <BiPencil color="#a3a3a3" size={15}></BiPencil>
        </g>
      </svg>
    )
  }
  //#endregion
}